import { result } from 'lodash';
import { Component, OnInit,Output,Input,EventEmitter,OnChanges,SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CoordinatorAddListComponent } from './popups/coordinator-add-list/coordinator-add-list.component';
import {CoordinatorsService} from '../services/coordinators.service'
import Utils from 'app/Utils';

@Component({
    selector: 'app-coordinators-list',
    templateUrl: './coordinators-list.component.html',
    styleUrls: ['./coordinators-list.component.scss'],
    standalone: false
})

export class CoordinatorsListComponent implements OnInit {
  @Output() nodeChange = new EventEmitter();
  @Input() nodeUpdate:any;

  coordinatorsDataSource=[];
  coordinatorsDataSourceInit=[];
  permissionList: Array<string>;
  permit801:number;
  doctorAddPremit:boolean=false;
  selectedItem;
  constructor(
    private dialog: MatDialog,
    private _coordinatorsService:CoordinatorsService,
    ) { }

  ngOnInit(): void {
    this.LoadAllCoordinators();
    this.permissionList = Utils.decrypt(localStorage.getItem('permissionIds')).split(',');
    this.permit801 = this.permissionList.indexOf('801');
    if (this.permit801 != -1) {
      this.doctorAddPremit = true;
    }
  }
  ngOnChanges(changes: SimpleChanges){
    if(this.nodeUpdate)
    {   
     this. LoadAllCoordinators();
    }
    
  }

  public AddnewCoordinator(): void {
    const modalRef = this.dialog.open(CoordinatorAddListComponent, {
    });
    modalRef.afterClosed().subscribe(res => {
        if(res)
        {
          this.nodeChange.emit(res.result);
        }
        this.LoadAllCoordinators();
    });
  }

  LoadAllCoordinators()
  {
    this._coordinatorsService.GetAllCoordinatorsList().subscribe(res => {   
      if(res)
      {
        this.coordinatorsDataSource=res.result;
        this.coordinatorsDataSourceInit=res.result;
      }
    }, err => {
    console.error(err);
    })
  }

  onSearchChange(searchString)
  {
    this.coordinatorsDataSource =this.coordinatorsDataSourceInit.filter(item => {
      if (item.nombre.toString().toLowerCase().indexOf(searchString.toLowerCase()) !== -1) {
        return true;
      }
    return false;
    }
    );
  }

  onNodesClick(nodes:any)
  {
    this.nodeChange.emit(nodes);
    this.selectedItem=nodes;
  }

}
